import { ActionCard } from "./ActionCard.js";
import { ACTION_CARD_COUNTS } from "@/game-rules/constants/actionCardCounts.js";

export class EnJoue extends ActionCard {
    static typeId = "EN_JOUE";
    static cardName = "En Joue !";
    static colorHex = "#3399FF";
    static countInDeck = ACTION_CARD_COUNTS.EN_JOUE;
    static description = "Posez une cible au dessus du mouton de votre choix. Il est désormais à la merci des tireurs !";

    isValidOn(slotIndex, gameState) {
        // Can only target a slot without target
        return !gameState.lineOfFireSlots[slotIndex].isTargeted;
    }

    resolve(slotIndex, gameState) {
        gameState.addTargetsToSlots([slotIndex]);
    }
}
